export const tagColors: string[] = [
	"#5eaf60", // light green
	"green", // green
	"#62bd9c", // turquoise green
	"#53a285", // muted green
	"#add8e6", // pastel sky blue
	"#5293c5", // light blue
	"#3280ba", // blue
	"blue", // pure blue
	"#3d556f", // dark slate blue
	"#dab0d8", // lighter violet
	"#a362bf", // purple
	"#e74b3c", // red orange
	"red", // red
	"#bf3b2c", // dark red
	"#000000", // black
];

export const pastelColors: string[] = [
	"#b8e0b9", // pastel light green
	"#a8d5a8", // pastel green
	"#b5dcc8", // pastel turquoise green
	"#a8cdb8", // pastel muted green
	"#c1e1c1", // pastel mint
	"#d4e8b8", // pastel lime
	"#e0ecc8", // pastel pale green
	"#cde8f0", // pastel sky blue
	"#b8d4e8", // pastel light blue
	"#a8c8e0", // pastel blue
	"#b8c8e8", // pastel periwinkle
	"#9fb0c4", // pastel slate blue
	"#b0b8d8", // pastel indigo
	"#b8e0e4", // pastel cyan
	"#c8e8ec", // pastel light cyan
	"#e8d4e6", // pastel lighter violet
	"#d4b8de", // pastel purple
	"#c8a8d4", // pastel dark purple
	"#f4c8d8", // pastel pink
	"#f8d8e0", // pastel light pink
	"#f4b8a8", // pastel red orange
	"#f0a8a0", // pastel red
	"#e09890", // pastel dark red
	"#d89088", // pastel crimson
	"#f8c8a8", // pastel coral
	"#f8d0a0", // pastel orange
	"#fcdcb0", // pastel light orange
	"#fce4a8", // pastel amber
	"#fce8b8", // pastel light amber
	"#fcecc0", // pastel yellow
	"#d4b8a8", // pastel brown
	"#c0a898", // pastel dark brown
	"#cca898", // pastel taupe
	"#b8c4cc", // pastel blue grey
	"#cccccc", // pastel grey
	"#a8a8a8", // pastel dark grey
	"#888888", // pastel black
];
